export default class EventsCollection {
  constructor() {
    this.collection = [];
  }
  add(entries, events) {
    const arr = Array.isArray(entries) ? entries : [entries];
    
    arr.forEach(name => {
      Object.entries(events)
        .forEach(([key, value]) => {
          this.collection.push({
            name,
            event: {
              type: key,
              callback: typeof value === 'function'
                ? props => value(props)
                : typeof value[0] === 'function'
                  ? props => value[0](props)
                  : () => {},
              /*
              * console.log(`value[0] is not a function: ${value[0]} ${name}`, value[0])
              *  It might be a bug*/
            },
          });
        });
    });
    return this;
  }
  get(id, props = {}) {
    return this.collection
      .filter(el => el.name === id)
      .reduce((acc, {name, event}) => {
        const {type, callback} = event;
        const sub = acc.find(sub => sub.type === type);
        if(sub) {
          sub.callbacks.push(callback);
        } else {
          acc.push({ type, callbacks: [callback] });
        }
        return acc;
      }, [])
      .reduce((acc, {type, callbacks}) => {
        acc[type] = () => callbacks
          // .filter(Boolean)
          .forEach(el => el(props));
        return acc;
      }, {})
  }
}